import store from "../../redux/store";
import { getAxiosInstance } from "../ApiConfig";
import { setCallingData } from "../../redux/CrmReduxCalls/ProductInteApiCalls";


async function getCalltoken() {
    try {
        const data = await getAxiosInstance().get(`/usermgmt/getTwilioToken`);
        return data.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function getCompanyCommunication() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCommunicationByCompany`);
        store.dispatch(setCallingData(response.data));
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAiIntegrationByCompany() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAiIntegrationByCompany`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CommunicationDelte(communicationId) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteCommunication/${communicationId}`)
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function DeleteAiIntegration(aiIntegrationId) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteAiIntegration/${aiIntegrationId}`)
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CommunicationSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createCommunication`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function CommunicationUpdate(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateCommunication/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function ComunicationDetailData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findCommunicationById/${id}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function CommunicationNumbers(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/twilio-numbers`, payload);
        return response;
    } catch (err) {
        const message = err?.response?.data?.error ? "Unable to authorize the Twilio account. Please verify your Twilio credentials and try again" : err.response.data.message.message;
        throw message;
    }
}
async function createAiIntegration(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createAiIntegration`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function UpdateAiIntegration(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateAiIntegration/${id}`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function saveSendGridConfig(payload) {
    try {
        const response = await getAxiosInstance().post(`/sendgrid/saveSendGridConfig`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getSendGridConfig() {
    try {
        const response = await getAxiosInstance().get(`/sendgrid/getSendGridConfig`);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function removeSendGridConfig(payload) {
    try {
        const response = await getAxiosInstance().put(`/sendgrid/removeSendGridConfig`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
export {
    saveSendGridConfig,
    removeSendGridConfig,
    DeleteAiIntegration,
    findAiIntegrationByCompany,
    CommunicationDelte,
    getCompanyCommunication,
    CommunicationSave,
    CommunicationUpdate,
    ComunicationDetailData,
    getCalltoken,
    CommunicationNumbers,
    createAiIntegration,
    UpdateAiIntegration,
    getSendGridConfig,
}